import { recognizedCommands } from "../constants/RecognizedCommands";

export interface ParsedReturn {
  template: string;
  command: string;
  flags?: Record<string, boolean>[];
}

export interface ParsedReturn {
  template: string;
  command: string;
  result?: string;
}

export const parseCommandsAndFlags = (userInput: string): ParsedReturn => {
  const wordArray = userInput.split(" ");
  const command = wordArray.shift()?.trim() || '';
  const parsedReturn: ParsedReturn = {
    template: userInput,
    command,
  };

  // Parse flags in unix style (--flag / -f syntax)
  const flags: Record<string, boolean> = {};
  for (const arg of wordArray) {
    if (arg.startsWith('--')) {
      // Long flag syntax
      const flagName = arg.slice(2);
      flags[flagName] = true;
    } else if (arg.startsWith('-')) {
      // Short flag syntax (support multiple flags in one arg)
      const flagChars = arg.slice(1).split('');
      flagChars.forEach(char => flags[char] = true);
    }
  }

  // Execute command callback if exists
  const commandObj = recognizedCommands[command];
  if (commandObj) {
    parsedReturn.template = `|${command}| \n` + commandObj.callback(flags);
    parsedReturn.result = commandObj.callback(flags);
  } else {
    parsedReturn.template = `|${command}|: command not found`;
  }
  return parsedReturn;
};
